import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatNumberByType } from "src/utils/formatting";

type Packaging = {
    name?: string | null;
    externalId?: string | null;
    weight?: number | null;
};

export type InfoSectionProps = {
    packaging: Packaging;
};
export const InformationSummary = (props: InfoSectionProps) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const { packaging } = props;
    const noValue = "-";
    const formattedWeight =
        packaging.weight == null ? noValue : formatNumberByType(packaging.weight, "grams", i18n.language, 3);

    return (
        <Box
            component="table"
            sx={{
                display: "table",
                width: "100%",
                "& tr > td": {
                    width: "430px",
                    borderBottom: `1px solid ${theme.custom.grey[500]}`,
                    padding: "20px 0px",
                },
            }}
        >
            <tbody>
                <tr>
                    <td>
                        <Typography variant="big-bold">{t("packagings.name")}</Typography>
                    </td>
                    <td>
                        <Typography variant="body-medium">{packaging.name || noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="big-bold">{t("unique_identifier")}</Typography>
                    </td>
                    <td>
                        <Typography variant="body-medium">{packaging.externalId || noValue}</Typography>
                    </td>
                </tr>
                <tr>
                    <td>
                        <Typography variant="big-bold">{t("glossary.weight", "Weight")}</Typography>
                    </td>
                    <td>
                        <Typography variant="body-medium">
                            {formattedWeight} {t("weight.grams", "grams")}
                        </Typography>
                    </td>
                </tr>
            </tbody>
        </Box>
    );
};
